import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { lighten } from '@mui/material';

interface CellProps {
  children: ReactNode;
  header?: boolean;
  isExpandable: boolean;
}

const Cell = ({ children, header = false, isExpandable }: CellProps) => {
  return (
    <Wrapper className="cell" header={+header} expandable={+isExpandable}>
      <div>{children || '-'}</div>
    </Wrapper>
  );
};

export default Cell;

const Wrapper = styled.div<{ header: number; expandable: number }>`
  text-transform: ${({ header }) => (header ? 'uppercase' : 'none')};
  font-size: ${({ header }) => (header ? '0.8rem' : 'inherit')};
  background: ${({ theme, header }) => (header ? theme.palette.background.default : lighten(theme.palette.background.paper, 0.02))};
  height: 100%;
  
  > div {
    align-items: center;
    display: flex;
    height: 100%;
  }
`;
